import dayjs from "dayjs";
import _ from "lodash";
import React, { useEffect, useState } from "react";

import { Text } from "@components/Text";
import { COLOR_WHITE } from "@static/COLORS";

export const DigitalClock = ({ fontSize, attribute }) => {
  const format = _.get(attribute, ["format"]);
  const [digitalTime, setDigitalTime] = useState("");

  const updateClock = () => {
    const timeFormat = format === 12 ? "hh:mm A" : "HH:mm";
    setDigitalTime(dayjs().format(timeFormat));
  };

  useEffect(() => {
    const timer = setInterval(updateClock, 1000);
    updateClock();

    return () => {
      clearInterval(timer);
    };
  }, [attribute]);

  return (
    <React.Fragment>
      <Text
        fontFamily="NotoSansThaiLooped"
        color={COLOR_WHITE}
        fontWeight="600"
        style={{ fontSize: `${fontSize}px`, whiteSpace: "nowrap" }}
      >
        {digitalTime}
      </Text>
    </React.Fragment>
  );
};
